import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  Output,
  ViewChild,
  SimpleChanges,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MerchantService } from '../../../models/merchant/merchantService';
import { PaymentMethodService } from '../../../models/paymentMethod/paymentMethodService';
import { environment } from '../../../../environments/environment';
import { Logging } from '../../../core/logging';

@Component({
  selector: 'app-tokenize-form',
  templateUrl: './tokenize-form.component.html',
  standalone: false,
})
export class TokenizeFormComponent {
  @Input() formName: string = '';
  @Input() customerId: string | undefined;
  @Input() merchantId: string | undefined;
  @Input() paymentType: string | undefined;
  @Input() hideButtons: boolean = false;
  @Output() onValidationChange = new EventEmitter<any>();
  @Output() onTokenized = new EventEmitter<any>();
  @Output() onCancelled = new EventEmitter<any>();

  @ViewChild('paymentFrame') paymentFrame: ElementRef | undefined;

  iframeSrc: SafeResourceUrl | undefined = undefined;

  paymentFormPassesValidation: boolean = false;

  constructor(
    private sanitizer: DomSanitizer,
    public merchantService: MerchantService,
    public paymentMethodService: PaymentMethodService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      customerId: string;
      merchantId: string;
      paymentType: string;
    },
  ) {
    if (data.merchantId) {
      this.merchantId = data.merchantId;
    }
    if (data.customerId) {
      this.customerId = data.customerId;
    }
    if (data.paymentType) {
      this.paymentType = data.paymentType;
    }
  }


  // ngOnChanges(changes: SimpleChanges) {
  //   console.log("changes: ", changes);
  //   let customerIdChange = changes['customerId'];

  //   if (customerIdChange) {
  //     if (customerIdChange.currentValue) {
  //       //this.loadCustomerInfo(customerIdChange.currentValue, false);
  //       //this.tokenizeForm?.updateCustomerId(this.customerId);
  //       //this.loadPaymentMethods();
  //     } else {
  //       this.customerId = undefined;
  //       this.tokenizeForm?.updateCustomerId('');
  //       this.paymentMethods = [];
  //     }
  //   }
  // }

  ngOnInit() {
    // console.log("Tokenize form initialized: merchantId = %s, customerId = %s, paymentType = %s", this.merchantId, this.customerId, this.paymentType);
    this.loadPaymentForm();
    if (this.paymentType == "ACH") {
      this.reloadframe();
    }
  }

  ngAfterViewInit() {
    window.addEventListener('message', (e) => {
      this.receiveMessageFromPaymentForm(e);
    });

    this.sendMessageToPaymentForm('ping');
  }

  ngOnDestroy() {}

  public reloadframe() {
    // If the component was initially hidden when the page loaded,
    // it will have width and height set to 0. To fix this, we
    // can ping the iframe for the layout size. This will
    // initiate a reply that includes the layout dimensions.
    this.loadPaymentForm().then(() => {});
  }

  public clearForm() {
    this.sendMessageToPaymentForm('clear');
  }

  public tokenize() {
    this.sendMessageToPaymentForm('tokenize');
  }

  public updateCustomerId(id: string | undefined) {
    if (!id) {
      this.sendMessageToPaymentForm({ action: 'updateCustomerId', value: '' });
    } else {
      this.sendMessageToPaymentForm({ action: 'updateCustomerId', value: id });
    }
  }

async loadPaymentForm() {
    const iframeURI =
      environment.gatewayUrl +
      '/mastercard/iframe.html?id=' +
      this.formName +
      '&mid=' +
      this.merchantId +
      '&cid=' +
      this.customerId +
      '&btntokenize=' + (this.hideButtons ? 'off' : 'on') +
      '&ptype=' +
      this.paymentType;
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(iframeURI);
  }

  public sendMessageToPaymentForm(message: any) {
    let ifr = this.paymentFrame?.nativeElement;
    if (ifr) {
      ifr.contentWindow.postMessage(message, '*');
    } else {
      console.warn('ifr not defined!');
    }
  }

  public receiveMessageFromPaymentForm(event: any) {

    if (event.data && event.data !== undefined) {
      try {
        const data = JSON.parse(event.data);

        if (data.id != this.formName) {
          // The message is not for this instance
          return;
        }

        let iFrame = document.getElementById('ifTokenize_' + this.formName);
        if (iFrame) {
          iFrame.setAttribute('width', data.width);
          iFrame.setAttribute('height', data.height);
        }

        switch (data.message) {
          case 'tokenized':
            this.onTokenized.emit(data);
            break;
          case 'cancelled':
            this.onCancelled.emit();
            break;
          //case 'getTokenizeData':
          //    this.onTokenized.emit(data);
          //    break;
          case 'validationChecked':
            this.onValidationChange.emit(data);
            break;
          case 'ach-tokenize':
            this.onTokenized.emit(data);
            break;
          case 'cleared':
            break;
        }
      } catch {
        // some messages don't have any data, and for some reason, even though
        // the data object is undefined, it's not detected by the outer
        // if statement above
      }
    }
  }

  async getPANIFrame(doTokenize: boolean, doAuthorize: boolean) {
    if (this.merchantId) {
      let headers = {
        'Content-Type': 'application/json',
      };

      let requestData = {
        customerId: this.customerId,
        merchantId: this.merchantId,
        //"merchantKey": this.data.apiKey,
        //"password": this.data.apiPassphrase,
        //"doTokenize": doTokenize,
        //"doAuthorize": doAuthorize
      };

      return await this.paymentMethodService.getTokenizationFormURL(
        this.customerId ? this.customerId : '',
        this.merchantId,
      );
    } else {
      throw 'no merchant selected';
    }
  }
}
